import {BaseOptions} from "../../../../dialog/options/base.options";

export class QrCodeOptions extends BaseOptions {
  space?: any;
}
